import axiosInstance from '../../../lib/axios';
import type { ServiceGroup } from '../types';

export async function listMyServices(): Promise<ServiceGroup[]> {
  const response = await axiosInstance.get('/v1/me/services', { skipErrorToast: true });
  return response.data.data;
}
